import {
  ChangeDetectionStrategy,
  Component,
  Input,
  output,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelDescription,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion';
import { MatChipListbox, MatChipOption } from '@angular/material/chips';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'lib-pegase-search-box',
  templateUrl: './search-box.component.html',
  styleUrls: ['./search-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatIconModule,
    MatExpansionPanel,
    MatAccordion,
    MatExpansionPanelDescription,
    MatChipListbox,
    MatExpansionPanelTitle,
    MatExpansionPanelHeader,
    MatChipOption,
    MatButton,
  ],
  standalone: true,
})
export class SearchBoxComponent {
  @Input() title!: string;
  @Input() badges!: string[];
  @Input() isExpanded = true;
  @Input() isSearchDisabled = false;
  @Input() btnReinitText = 'RÉINITIALISER';
  @Input() btnSearchText = 'RECHERCHER';
  @Input() useSearchBtn = true;

  readonly reinit = output<boolean>();
  readonly searchEvent = output<boolean>();

  reinitForm() {
    this.reinit.emit(true);
  }

  searchForm() {
    this.searchEvent.emit(true);
  }
}
